<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">
        {{ editing ? "Editar banco" : "Nuevo banco" }}
      </h1>
    </div>

    <div>
      <form class="custom-form" @submit.prevent="save" novalidate>
        <b-card tag="article" no-body style="max-width: 600px" class="custom-card">
          <b-card-header header-tag="section" class="custom-card-header d-flex align-items-center">
            <h3>{{ editing ? "Datos del banco" : "Datos del nuevo banco" }}</h3>
          </b-card-header>

          <b-card-body class="custom-card-body p-0">
            <section class="form-section mb-0">
              <div class="row">

                <!-- Código -->
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="code">Código <span class="text-danger">*</span></label>
                    <input
                      id="code"
                      type="text"
                      v-model="form.code"
                      autocomplete="off"
                      placeholder="Ej: 002"
                      class="custom-form-control"
                      :class="{ 'custom-form-control-error': $v.form.code.$error }"
                    />
                    <FormError
                      v-if="$v.form.code.$error && !$v.form.code.required"
                      message="El código es requerido"
                    />
                  </div>
                </div>

                <!-- Nombre -->
                <div class="col-md-8">
                  <div class="form-group">
                    <label for="name">Nombre <span class="text-danger">*</span></label>
                    <input
                      id="name"
                      type="text"
                      v-model="form.name"
                      autocomplete="off"
                      placeholder="Nombre del banco"
                      class="custom-form-control"
                      :class="{ 'custom-form-control-error': $v.form.name.$error }"
                    />
                    <FormError
                      v-if="$v.form.name.$error && !$v.form.name.required"
                      message="El nombre es requerido"
                    />
                  </div>
                </div>

              </div>

              <div class="form-group-buttons text-right">
                <router-link :to="{ name: 'bank-list' }" class="button button-light">
                  {{ editing ? "Volver" : "Cancelar" }}
                </router-link>
                <button class="button button-primary" type="submit">Guardar</button>
              </div>
            </section>
          </b-card-body>
        </b-card>
      </form>
    </div>
  </div>
</template>

<script>
import { Alert, FormError } from "wize-admin";
import { required } from "vuelidate/lib/validators";
import { BankService } from "@/core/services";

export default {
  components: { FormError },

  data() {
    return {
      editing: false,
      form: {
        name: null,
        code: null,
      },
    };
  },

  validations: {
    form: {
      name: { required },
      code: { required },
    },
  },

  watch: {
    "$route.params.id": function () {
      if (this.$route.params.id) this.load(this.$route.params.id);
    },
  },

  methods: {
    async save() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.$nextTick(() => {
          this.$smoothScroll({
            scrollTo: document.querySelector(".form-error"),
            updateHistory: false,
            offset: -50,
          });
        });
        return;
      }

      try {
        this.$store.dispatch("app/loading", true);
        const data = { name: this.form.name, code: this.form.code };
        let response;
        if (!this.editing) response = await BankService.save(data);
        else response = await BankService.update(this.$route.params.id, data);

        Alert.success("Se almacenó la información correctamente");
        if (!this.editing) {
          this.$router.push({
            name: "bank-edit",
            params: { id: response.payload.id },
          });
          this.editing = true;
        }
      } catch (ex) {
        console.error(ex);
        Alert.error(ex.errors ? ex.errors.message : "Error al guardar");
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },

    async load(id) {
      try {
        this.$store.dispatch("app/loading", true);
        const payload = (await BankService.get(id)).payload;
        this.form = { name: payload.name, code: payload.code };
        this.editing = true;
      } catch (e) {
        console.error(e);
        Alert.error(e.errors ? e.errors.message : "Error al cargar el banco");
        this.$router.push({ name: "bank-list" });
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
  },

  async created() {
    if (this.$route.params.id) this.load(this.$route.params.id);
  },
};
</script>

<style lang="stylus" scoped></style>
